import header from '../modules/header/index';
import initInfoGallery from '../modules/initInfoGallery';
import addHightToImageGalery from '../modules/addHightToImageGalery';
import productTooltipControl from '../modules/productTooltipControl';
import addScrollToTop from '../modules/addScrollToTop';
import NewsletterAction from '../modules/newsletterAction';
import tabPanel from '../modules/tabPanel/tabPanelIndex';
import asideMobileOpener from '../modules/asideMobileOpener';
import initAndra from '../modules/initAndra';
import {Apptus} from '../modules/apptus/apptus';
import viewModeMobileHandler from '../modules/header/components/viewModeMobileHandler';

import "../../../scss/pages/allStyles.scss";

jQuery(function() {
  header();
  initInfoGallery();
  addHightToImageGalery();
  productTooltipControl();
  addScrollToTop();
  asideMobileOpener();
  initAndra();
  tabPanel();
  viewModeMobileHandler();

  if (window.innerWidth <= 767) {
    $('#sidebar').appendTo('.mobile-filter-block');
    $('.ctrl-container.search-panel').prependTo('.drop-container');
  } else {
    $('#sidebar').prependTo('#twocolumns');
    if ($('#sidebar .ctrl-container.search-panel').length) {
      $('.ctrl-container.search-panel').insertAfter('.tab-panel');
    }
  }

  $('.subscription').on('click', function() {
    NewsletterAction($(this));
  });

  $(window).on('click', (e) => {
    
    let target = e.target;
    var targetParent = $(target).parent();
    if(target.matches('.update-apptus-func') ) {
        Apptus.NotifyClick($(target).attr('data-apptus'))
    }
    if(targetParent.hasClass('update-apptus-func') ) {
        Apptus.NotifyClick($(targetParent).attr('data-apptus'))
    }
  })
})